import { useSelector } from 'react-redux';

import { useEnableNewSidebar } from 'src/hooks/useEnableNewSidebar';
import { useSidebarTheme } from 'src/legacy/components/Sidebar/useSidebarTheme';
import { RootState } from 'src/store';
import { NonHoverBorder, SidebarColors } from 'src/theme/colors';

const GRAY_150 = '#EFF1F4';
const TEXT_PRIMARY = '#212B36';

export const useNotificationBadgeData = (isSidebar: boolean = false) => {
  const { sidebarTheme } = useSidebarTheme();
  const isClient = useSelector((state: RootState) => state.user.isClient);
  const enableNewSidebar = useEnableNewSidebar();

  // Calculate colors based on user type and context
  const backgroundColor = isSidebar
    ? isClient
      ? sidebarTheme.sidebarTextColor
      : enableNewSidebar
        ? GRAY_150
        : NonHoverBorder
    : 'var(--primary-color, #1976d2)'; // Default primary color

  const textColor = isSidebar
    ? isClient
      ? sidebarTheme.sidebarBackgroundColor
      : enableNewSidebar
        ? TEXT_PRIMARY
        : SidebarColors.InternalSidebarText
    : 'var(--primary-contrast-text, #ffffff)'; // Default contrast text

  return {
    backgroundColor,
    textColor,
  };
};
